// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"272":"14cd2bc2","479":"054b46d4","617":"451e56f3","957":"0e86affd"}[chunkId] + ".css";
};